import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const pcdfVersionHistorySlice = createSlice({
  name: 'pcdfVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default pcdfVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = pcdfVersionHistorySlice.actions;
